// Export
module.exports =
{


    //example modals below
    /*modals: 
    {
        main: 
        {
            display: 'flex', // display type
            colour: '#EBF8FD', // background colour
            height: '0.77790178571',  // percentage of screen height to set height
            maxWidth: "calc(100vw - 40px)",
            invertCross: true, // invert the colours of the modal close cross
            center: true,
        }, 
        error: 
        {
            display: 'flex', 
            colour: '#EBF8FD',
            height: '0.77790178571',
            width: "380px",
            invertCross: true,
            center: true,
        },
        denied:
        {
            display: 'flex', 
            colour: '#2B8CC6',
            height: '0.56473214285',
            width: "380px",
            center: true,
        },
        success:
        {
            display: 'flex',
            colour: '#2B8CC6',
            height: '0.56473214285',
            width: "380px",
            center: true,
        },
        holding: 
        {
            display: 'flex', 
            colour: '#EBF8FD',
            px_height: '363px',
            width: "380px",
            noCross: true,
            disableClose: true,
            center: true,
        },
    },*/
    selected_modal: "",
    modals: {},
    
    modalResize: function () {
        const modalElement = document.querySelector(`#modal-box:has(#${this.selected_modal})`) || 
                            document.querySelector(`#${this.selected_modal}:has(#modal-box) #modal-box`);
        
        if (!modalElement) return;

        let bodyElement = modalElement?.querySelector(`#${this.selected_modal}`);

        if(!bodyElement){
            return
        }

        if (this.modals[this.selected_modal].height) {
            modalElement.style.height = `${this.modals[this.selected_modal].height * Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)}px`;
        }
        if (this.modals[this.selected_modal].px_height) {
            modalElement.style.height = this.modals[this.selected_modal].px_height;
        }
        if (this.modals[this.selected_modal].auto_height) {
            modalElement.style.height = "auto";
        }
    },
    showModal: function(modal){
        module.exports.resetModalInline()
        let this_class = this
        Object.keys(this.modals).forEach(function(key){
            

            if(key == modal){
                let modalBox = document.querySelector(`#modal-box:has(#${key})`) || 
                            document.querySelector(`#${key}:has(#modal-box) #modal-box`);

                let modalElement = document.querySelector(`#${key}`);
                if (modalElement) {
                    modalElement.style.display = this_class.modals[key].display
                }

                if (modalBox) {

                    modalBox.style.backgroundColor = this_class.modals[key].colour

                    if(this_class.modals[key].width){
                        modalBox.style.setProperty("width", this_class.modals[key].width)
                    }
                    if(this_class.modals[key].px_height){
                        modalBox.style.setProperty("height", this_class.modals[key].px_height)
                    }
                    if(this_class.modals[key].center){
                        modalBox.style.setProperty("margin", "auto")
                    }
                    if(this_class.modals[key].maxWidth){
                        modalBox.style.setProperty("max-width", this_class.modals[key].maxWidth)
                    }
                    if(this_class.modals[key].maxHeight){
                        modalBox.style.setProperty("max-height", this_class.modals[key].maxHeight)
                    }
                    
                    let crossImage = modalBox.querySelector(".bubble-modal-close > img")
                    if (crossImage) {
                        crossImage.src = this_class.modals[key].invertCross ? 
                            "/includes/assets/images/modal-cross-black.png" : 
                            "/includes/assets/images/modal-cross.png";
                    }

                    if(this_class.modals[key].noCross){
                        let closeButton = modalBox.querySelector(".bubble-modal-close")
                        if (closeButton) {
                            closeButton.style.display = "none"
                            if(document.querySelector(".bubble-modal-box")){
                                document.querySelector(".bubble-modal-box").style.cssText += ' border-top-right-radius: 16px !important; '  
                            }
                        }
                    }
                    
                    let modalClose = modalBox.querySelector(".bubble-modal-close")
                    if (modalClose) {
                        modalClose.style.backgroundColor = this_class.modals[key].colour
                    }
                }

                this_class.selected_modal = modal // set the modal that will be used in the resize listener
                this_class.modalResize()
            }
            else{

                let modalElement = document?.querySelector(`#${key}`);

                if (modalElement) {
                    modalElement.style.display = "none"
                }
            }
        })
    },

    resetModalInline: function(){
        const modalBox = document.querySelector(`#modal-box:has(#${this.selected_modal})`) || 
                        document.querySelector(`#${this.selected_modal}:has(#modal-box) #modal-box`);
        
        if (modalBox) {
            modalBox.style.width = "";
            modalBox.style.height = "";
            modalBox.style.maxWidth = "";
            modalBox.style.backgroundColor = "";
            modalBox.style.margin = "";
            modalBox.querySelector(".bubble-modal-close")?.style.setProperty("display", "");
            modalBox.style.borderTopRightRadius = "";
        }
    },
    resetModal: function(){
        $('body').removeClass('show-modal'); // close the modal
        $('html').removeClass('tw-overflow-hidden');
        //add the old close button back
        const modalBox = document.querySelector(`#modal-box:has(#${this.selected_modal})`) || 
                        document.querySelector(`#${this.selected_modal}:has(#modal-box) #modal-box`);

        if($(modalBox)?.find("> span").length > 0){
            $(modalBox)?.find("> span")?.remove()
            modalBox.insertAdjacentHTML("afterbegin", `<span></span>`);
            $(modalBox).find("> span").on("click", () => {
                $('body').removeClass('show-modal');
            });
        }

        module.exports.resetModalInline();
        if(modalBox && document.querySelector(`#modal-box:has(#${this.selected_modal})`) ){
            $(modalBox).empty();
            $(modalBox).append("<span class></span><div id='modal-body-box'></div>");
            $(modalBox).removeClass("modal-box");
        }
    },

    /**
     * @param {string} selected_modal - the modal to be shown
     * @param {object} modals - object of modals to be used
     * @param {function} callback - callback function to be called after the modal has been setup
     */
    setupModals: function (selected_modal, modals, callback = () => {}){

        this.modals = modals
        this.selected_modal = selected_modal

        // custom modal setup
        if(document.querySelector(`#modal-box:has(#${selected_modal})`)){
            document.querySelector(`#modal-box:has(#${selected_modal})`)?.querySelector("& > span")?.remove() // remove the currect close button 
            document.querySelector(`#modal-container:has(#${selected_modal})`).style.flexDirection = "column"
            document.querySelector(`#modal-box:has(#${selected_modal}):not(:has(.bubble-modal-close))`)?.insertAdjacentHTML("afterbegin", `<div class="bubble-modal-close" style="background-color: light_blue;" ><img src="/includes/assets/images/modal-cross.png"/></div>`)
            document.querySelector(`#modal-box:has(#${selected_modal})`)?.classList.add("bubble-modal-box")
            $(".bubble-modal-close-button").on("click", this.resetModal)
            $(".bubble-modal-close").on("click", this.resetModal)
        }
        // inline modal setup
        else if(document.querySelector(`#${selected_modal}:has(#modal-box)`)){
            $('html').addClass('tw-overflow-hidden');
            document.querySelector(`#${selected_modal}:has(#modal-box) #modal-box`)?.querySelector("& > span")?.remove() // remove the currect close button 
            document.querySelector(`#${selected_modal}:has(#modal-box) #modal-container`).style.flexDirection = "column"
            document.querySelector(`#${selected_modal}:has(#modal-box) #modal-box:not(:has(.bubble-modal-close))`)?.insertAdjacentHTML("afterbegin", `<div class="bubble-modal-close" style="background-color: light_blue;" ><img src="/includes/assets/images/modal-cross.png"/></div>`)
            document.querySelector(`#${selected_modal}:has(#modal-box) #modal-box`)?.classList.add("bubble-modal-box")
            $(`#${selected_modal}`).on("click", (e) => {
                // make sure the click wasnt within the modal-body-box, the bubble-modal-close-button or the bubble-modal-close
                if(!e.target.closest(".bubble-modal-body")){
                    this.resetModal()
                    $(`.modal#${selected_modal}`).modal('hide')
                    
                }
            })
            $(`#${selected_modal} .bubble-modal-close-button`).on("click",  () => {$(`#${selected_modal}`).trigger("click")})
            $(`#${selected_modal} .bubble-modal-close`).on("click", () => {$(`#${selected_modal}`).trigger("click")})
        }

        window.addEventListener("resize", () => {   
            this.modalResize()
        })

        this.showModal(selected_modal)
        
        callback()
    },

        
    

}
